export default "__VITE_ASSET__C6U7$HsM__"